// recentDrawers — small localStorage-backed tracker for the last drawers
// the user has opened across the platform. Powers the sidebar "Recent" list.
//
// Each entry shape:
//   { id, label, path, severity, ts }

const KEY = 'apex-recent-drawers';
const MAX = 5;
const EVT = 'apex:recent-drawers';

function safeRead() {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    // Storage disabled (private mode) or quota exceeded — degrade gracefully.
    if (typeof console !== 'undefined') console.warn('[recentDrawers] read failed', err);
    return [];
  }
}

function safeWrite(list) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent(EVT));
  } catch (err) {
    // Storage disabled (private mode) or quota exceeded — log & no-op.
    if (typeof console !== 'undefined') console.warn('[recentDrawers] write failed', err);
  }
}

export function pushRecentDrawer(entry) {
  if (!entry || !entry.id) return;
  const list = safeRead();
  const dedup = list.filter((it) => it.id !== entry.id);
  dedup.unshift({ ...entry, ts: Date.now() });
  safeWrite(dedup.slice(0, MAX));
}

export function clearRecentDrawers() {
  safeWrite([]);
}

export function readRecentDrawers() {
  return safeRead();
}

export const RECENT_DRAWERS_EVENT = EVT;
